import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Scenario } from "../../models/scenario.model";

import { _ } from '../../app/extract';

@Injectable()
export class ScenarioProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);

    _('SCENARIO_OUT_OF_ORDER_LIVE_PRODUCT');
    _('SCENARIO_MISSING_LIVE_PRODUCT');
    _('SCENARIO_OUT_OF_ORDER_CTU_OR_FSDU');
    _('SCENARIO_STOLEN_LIVE_PRODUCT');
    _('SCENARIO_BLOCKED_APK');
    _('SCENARIO_PRICE_ALERT');
    _('SCENARIO_OTHER');

    _('NOTIFICATION_RANK_UP');
    _('NOTIFICATION_USER_RANK_UP');
    _('NOTIFICATION_INCIDENT_REPORTED');
    _('NOTIFICATION_INCIDENT_STATUS_IN_PROGRESS');
    _('NOTIFICATION_INCIDENT_STATUS_DONE');
  }

  getAll(): Observable<Scenario[]> {
    return this.http
      .get<Scenario[]>(`${this.url}/scenarios`)
      .map(response => {
        return response.map((scenario) => new Scenario(scenario));
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/scenario/scenario.ts